import React, { useEffect, useState } from "react";
import "./Button.scss";
import { Link } from "gatsby";

const CTAButton = ({ text, link }) => {
  return (
    <Link className="Button Button__CTAButton" href={link}>
      {text}
    </Link>
  );
};

const ReturnToTop = () => {
  const [isVisible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 400) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <button
      className={`${
        isVisible
          ? "Button Button__ReturnToTop Button__ReturnToTop--active"
          : "Button Button__ReturnToTop "
      }`}
      onClick={scrollToTop}
    >
      RETURN TO TOP
    </button>
  );
};

export { CTAButton, ReturnToTop };
